export default __webpack_public_path__ + "static/media/AppStore.2375e46d.png";